"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assembleUrlParams = void 0;
Object.defineProperty(exports, "builtInParamNames", {
  enumerable: true,
  get: function get() {
    return _constants.builtInParamNames;
  }
});
exports.formViewLink = void 0;
exports.internalUrl = internalUrl;
exports.mapParameters = void 0;
Object.defineProperty(exports, "standardTokenNames", {
  enumerable: true,
  get: function get() {
    return _constants.standardTokenNames;
  }
});
var _ramda = require("ramda");
var _urlHelpers = require("../urlHelpers");
var _constants = require("../constants");
var _urlBuilder = _interopRequireDefault(require("../urlBuilder"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// Object -> String
// Returns a URL parameter list containing the key/value pairs in the provided object
// or an empty string if no object is provided
var mapParameters = exports.mapParameters = (0, _ramda.compose)((0, _ramda.join)('&'), (0, _ramda.map)(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    k = _ref2[0],
    v = _ref2[1];
  return "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v));
}), _ramda.toPairs, (0, _ramda.defaultTo)({}));

// [String] -> { String: String }
// Finds the URL parameters matching the specified list of names and returns an object
// mapping of names to their corresponding values
var assembleUrlParams = exports.assembleUrlParams = (0, _ramda.compose)(_ramda.fromPairs, (0, _ramda.filter)(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    v = _ref4[1];
  return v;
}), (0, _ramda.map)(function (k) {
  return [k, (0, _urlHelpers.getParameterByName)(k)];
}));

// (String, {String: String}) -> String
function internalUrl(path, parameters) {
  var query = mapParameters(_objectSpread(_objectSpread({}, assembleUrlParams(_constants.standardTokenNames)), parameters || {}));
  return "".concat(path).concat(query ? '?' : '').concat(query);
}
var formViewLink = exports.formViewLink = function formViewLink(templateName) {
  var anonymous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0, _urlBuilder["default"])(window.location.search).viewForm(templateName, {
    anonymous: anonymous
  });
};